import React, { useEffect, useState } from "react";
import { EPAPER_BANNER_TEXT } from "../../../constants";
import PVLogo from "../other-icons/PVLogo";
import NandiIcon from "../other-icons/Badge";

import "./new-body-banner.m.css";

const PREMIUM_URL = "https://www.prajavani.net/premium?session=pvsite&source=inarticlebanner&medium=premiumredirection";

const NewBodyWidget = () => {
  const [isMobile, setIsMobile] = useState(false);

  const epaperUrl = PREMIUM_URL;

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  const handleAnalytics = () => {
    if (typeof window !== "undefined" && window.dataLayer && typeof pushEventToDataLayer === "function") {
      pushEventToDataLayer("ePaper_banner");
    }
  };

  const desktopImage = "https://tpml-sites.s3.ap-south-1.amazonaws.com/images/pv_dsktp_article.png";
  const mobileImage = "https://tpml-sites.s3.ap-south-1.amazonaws.com/images/pv_mw_article.png";

  return (
    <a
      href={epaperUrl}
      target="_blank"
      rel="noopener noreferrer"
      styleName="epaper-banner"
      onClick={handleAnalytics}
    >
      <div styleName="epaper-left">
        <div styleName="logo-wrapper">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 234 112" fill="none" preserveAspectRatio="none" styleName="epaper-placeholder">
            <path d="M0 112L205.588 112L233.532 0H0V112Z" fill="#D9D9D9"/>
            <path d="M0 112L205.588 112L233.532 0H0V112Z" fill="url(#paint0_linear_52_821)"/>
            <defs>
              <linearGradient id="paint0_linear_52_821" x1="118.719" y1="146.929" x2="182.396" y2="-32.222" gradientUnits="userSpaceOnUse">
                <stop stopColor="#2F0005"/>
                <stop offset="1" stopColor="#6B0D1A"/>
              </linearGradient>
            </defs>
          </svg>
          <div styleName="banner-logo">
            <PVLogo />
          </div>
          <div styleName="banner-premium-badge">
            <NandiIcon viewBox="4 7 25 18" styleName="bannerPremiumBadgeIcon" />
            <span styleName="premiumBadgeText">ಪ್ರೀಮಿಯಂ</span>
          </div>
        </div>

        <div styleName="epaper-text">
          <h2 styleName="epaper-heading">
            <span>
              {EPAPER_BANNER_TEXT.PAPER_BANNER_HEADING_1}
            </span>
          </h2>

          <p styleName="epaper-subheading">{EPAPER_BANNER_TEXT.PAPER_BANNER_SUBHEADING}</p>
        </div>
      </div>

      <div styleName="epaper-cta">
        <span>ಈಗಲೇ ಅನ್ವೇಷಿಸಿ</span>
      </div>
    </a>
  );
};

export default NewBodyWidget;
